// extracted by mini-css-extract-plugin
module.exports = {"modalBox":"SignUpModal_modalBox__q8OcX","modalCloseButton":"SignUpModal_modalCloseButton__ZJAeo"};